import PropTypes from 'prop-types';
import React from 'react';
import UrlHelpers from '../../shared/url_helpers';
import Loading from '../../shared/loading';
import TableElement from './table/element';
import TableNav from './table/nav';
import TableHeader from './table/header';
import { UI } from '../../legacy/ui';
import { HashUtil, APIRequest } from '@reverbdotcom/discovery-ui';

const PAGE_SIZE = 10;
const DEFAULT_PARAMS = { per_page: PAGE_SIZE };
const COMPARISON_SHOPPING_PAGE = 'comparisonShoppingPage';

class PriceGuideTable extends React.Component {
  constructor() {
    super();

    this.state = {
      condition: 'used',
      loaded: false,
      hasError: false,
    };

    this.fetchNextPagination = this.fetchNextPagination.bind(this);
    this.fetchPreviousPagination = this.fetchPreviousPagination.bind(this);
  }

  componentDidMount() {
    const url = this.buildUrl(DEFAULT_PARAMS);
    this.fetch(url);
  }

  setCondition(condition) {
    const params = $.extend({ condition }, DEFAULT_PARAMS);
    const url = this.buildUrl(params);

    this.fetch(url).then(() => {
      this.setState({ condition });
    });
  }

  getTableStructure() {
    if (this.isReady()) {
      return (
        <section className="transaction-history">
          <TableHeader
            onConditionClick={condition => this.setCondition(condition)}
            selectedCondition={this.state.condition}
          />
          <div className="module mb-2 position-relative btm-round-module">
            <TableElement
              transactions={this.state.model.transactions}
              signedIn={UI.isLoggedIn()}
              productTypeUuid={this.props.productTypeUuid}
            />
            <div className="transaction-history__footer">
              <div className="transaction-history__footer__hint">
                {I18n.t('js.transactionHistory.excludesVat')}
              </div>
              <div className="transaction-history__footer__nav">
                <TableNav
                  onNextClick={this.fetchNextPagination}
                  onPrevClick={this.fetchPreviousPagination}
                  nextLink={this.nextLink}
                  prevLink={this.prevLink}
                />
              </div>
            </div>
          </div>
        </section>
      );
    }
    return false;
  }

  fetchNextPagination() {
    const url = this.nextLinkHref;
    if (url) {
      this.fetch(url);
    }
  }

  fetchPreviousPagination() {
    const url = this.prevLinkHref;
    if (url) {
      this.fetch(url);
    }
  }

  get nextLink() {
    return HashUtil.getSafely(this.state, 'model._links.next');
  }

  get prevLink() {
    return HashUtil.getSafely(this.state, 'model._links.prev');
  }

  get nextLinkHref() {
    return HashUtil.getSafely(this.state, 'model._links.next.href');
  }

  get prevLinkHref() {
    return HashUtil.getSafely(this.state, 'model._links.prev.href');
  }

  isReady() {
    return this.state.model;
  }

  fetch(url) {
    const req = APIRequest.V3.get(url);

    req.then((resp) => {
      this.setState({ model: resp, loaded: true, hasError: false });
    });

    req.fail(() => this.setState({ loaded: true, hasError: true }));
    return req;
  }

  buildUrl(params) {
    if (this.props.objectType === COMPARISON_SHOPPING_PAGE) {
      return UrlHelpers.comparisonShoppinagPageTransactionsPath(this.props.objectId, params);
    }

    return UrlHelpers.priceGuideTransactionsPath(this.props.objectId, params);
  }

  render() {
    const table = this.getTableStructure();
    return (
      <Loading
        loaded={this.state.loaded}
        hasError={this.state.hasError}
        errorMessage={I18n.t('js.transactionHistory.error')}
      >
        {table}
      </Loading>
    );
  }
}

PriceGuideTable.propTypes = {
  objectId: PropTypes.number.isRequired,
  objectType: PropTypes.string,
  productTypeUuid: PropTypes.string,
};

export default PriceGuideTable;
